<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Receipt</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabsNav">
              <v-tab @click.native="doValidateMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doValidateMandatory(1)">Optional</v-tab>
              <v-tab @click.native="doValidateMandatory(2)">Payment Method</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabsNav">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="receiptsMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="receiptsFormLabel.docAE" v-model="receiptsForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.transactionDateDisp }}</v-subheader>
                              <div class="queryValue">{{ convertDate(receiptsForm.transactionDateDisp) }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.receivedFrom }}</v-subheader>
                              <div class="queryValue" v-for="item in filterReceivedFromList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.depositAcct }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepositAcctList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md1 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.accountNoSuffixDesc }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAcctNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.paymentMethod }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPaymentMethodList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.amountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLaitemsbel">{{ receiptsFormLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.gstAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="receiptsForm.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.netAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.bankAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="receiptsForm.bankAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankAmount }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.bankAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankChargesCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.bankChargesCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankCharges }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.bankCharges }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankTotalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.bankTotalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankTotalAmount }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.bankTotalAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankTotalLocalCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(receiptsForm.bankTotalLocalCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="receiptsForm.bankTotalLocalAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.bankTotalLocal }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.bankTotalLocal }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.createdBy + ' on ' + receiptsForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.modifiedBy + ' on ' + receiptsForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="receiptsOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocOptList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.details }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-textarea
                                v-model="receiptsForm.statementRef"
                                :label="receiptsFormLabel.statementRef"
                                disabled
                                no-resize
                                rows="3"
                              ></v-textarea>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepartmentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="paymentmethod">
                <form data-vv-scope="receiptsPaymentForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.payerBank }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPayerBankList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.payersChequeNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.payersChequeNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.drawerName }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.drawerName }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ receiptsFormLabel.creditCardNo }}</v-subheader>
                              <div class="queryValue">{{ receiptsForm.creditCardNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg12 xs12 order-lg1 order-xs2>
                  <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :mode="'query'"></common-comments>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-information</v-icon>
              <v-toolbar-title>System Information</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <span class="info-dialog-msg-header">Oops something went wrong...</span>
                <v-spacer class="mt-2"></v-spacer>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{ error.message }}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { receiptsViewMixin } from '@/mixins/accounting/receipts/receiptsViewMixin'
import { receiptsAjaxMixin } from '@/mixins/accounting/receipts/receiptsAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      receiptTabs: ['Mandatory', 'Optional', 'Payment Method'],
      tabsNav: 0,
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      branches: [],
      currencies: [],
      payerbanks: [],
      paymentmethods: [],
      departments: [],
      cashbooks: [],
      miscacctparams: [],
      paymentmethod: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      trandaterange: {},
      gstStatuses: [],
      funds: [],
      gstrate: '0.00',
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now',
        matchLater: 'Match Later',
        matchRBC: 'Match RBC'
      },
      validStatus: {
        mandatory: true,
        optional: true,
        paymentmethod: true
      },
      receiptErrors: [],
      promptConfirmation: false,
      isExistChequeNo: false,
      actionName: null,
      banks: [],
      acctnosuffixes: [],
      accounts: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.receiptsForm.branch
      })
    },
    filterReceivedFromList() {
      return this.accounts.filter((list) => {
        return list.value === this.receiptsForm.receivedFrom
      })
    },
    filterDepositAcctList() {
      return this.banks.filter((list) => {
        return list.value === this.receiptsForm.depositAcct
      })
    },
    filterAcctNoSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.receiptsForm.accountNoSuffixDesc
      })
    },
    filterPaymentMethodList() {
      return this.paymentmethods.filter((list) => {
        return list.value === this.receiptsForm.paymentMethod
      })
    },
    filterGstIOList() {
      return this.gstIOOptions.filter((list) => {
        return list.value === this.receiptsForm.gstIO
      })
    },
    filterGstStatList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.receiptsForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.receiptsForm.amountCurr
      })
    },
    filterPrintDocOptList() {
      return this.printDocOptions.filter((list) => {
        return list.value === this.receiptsForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOptions.filter((list) => {
        return list.value === this.receiptsForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.receiptsForm.department
      })
    },
    filterPayerBankList() {
      return this.payerbanks.filter((list) => {
        return list.value === this.receiptsForm.payerBank
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.receiptsForm.fund
      })
    },
    commentRefNo() {
      const data = this.$store.state.receipt.receiptData
      return data.acctNo + data.docNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.receipt.receiptData.type
    }
  },
  methods: {
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    doValidateMandatory(tabId) {
      if (tabId === 1) {
        this.validStatus.mandatory = true
        this.tabsNav = tabId
      } else if (tabId === 2) {
        this.validStatus.optional = true
        this.tabsNav = tabId
      } else if (tabId === 3) {
      }
    },
    defaultAmount() {
      return (0.0).toFixed(2)
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonData('miscacctparams')
      this.fetchBranch()
      this.fetchFund()
      this.fetchCurrency()
      this.fetchPayerBank()
      this.fetchPaymentMethod()
      this.fetchDepartment()
      this.fetchCashBook()
      this.fetchAmountCurrency()
      this.fetchCurrency()
      this.fetchGstStatus()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchAccount()
      await Promise.all([this.performReview()])
    },
    getPaymentMethod(payment) {
      this.getCommonData('paymentmethod', payment)
    },
    doCancel() {
      this.$router.push({ name: 'receipts' }).catch(() => {})
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, receiptsViewMixin, receiptsAjaxMixin, commonAjaxMixin],
  components: {
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
